import ValueSchemaEditorForm from './ValueSchemaEditorForm';
import { useLanguage } from '../../contexts/LanguageContext';

export default function ValueSchemaManagerPanel({ schemas, onReload, saving, setSaving }) {
  const { t } = useLanguage();
  return (
    <div className='space-y-4'>
      <p className='text-xs text-muted-foreground'>{t('periodization.valueSchema.hint')}</p>
      <ValueSchemaEditorForm
        schemas={schemas}
        onReload={onReload}
        saving={saving}
        setSaving={setSaving}
        mode='user'
        allowEditGlobal={false}
      />
    </div>
  );
}
